import { Injectable } from '@angular/core';

@Injectable()
export class DialogsService{
    confirm:(Title: string, Message: string, cancelButtonText: string, okButtonText: string) => Promise<boolean>;
}